import "antd/lib/style/themes/default.less";
import "antd/dist/antd.less"; // Import Ant Design styles by less entry
import "./src/theme/global.less";
import React from "react";
import { withPrefix } from "gatsby";
import { StoreProvider } from "./src/store";
import PrivateRoute from "./src/services/PrivateRoute";
import { clearStale } from "./src/services/auth";

//#region ===== AliCloud Upload SDK Global Load =====
let aliyunUploadSdkLoaded = false;

const loadAliyunUploadSDK = () => {
  if (aliyunUploadSdkLoaded || typeof window === "undefined") return;

  const scripts = [
    "lib/aliyun-upload-sdk/lib/es6-promise.min.js",
    "lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.7.min.js",
    "lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-6.17.1.min.js",
  ];

  scripts.forEach((src) => {
    const scriptUrl = withPrefix(src.startsWith("/") ? src : `/${src}`);
    if (document.querySelector(`script[src="${scriptUrl}"]`)) return;

    const script = document.createElement("script");
    script.src = scriptUrl;
    script.defer = true;
    script.onload = () => {
      if (src.includes("upload-sdk")) {
        aliyunUploadSdkLoaded = true;
        console.log("AliCloud upload SDK loaded");
      }
    };
    script.onerror = () => {
      console.error("AliCloud upload SDK failed to load:", scriptUrl);
    };
    document.head.appendChild(script);
  });
};
//#endregion

export const wrapRootElement = ({ element }) => {
  return <StoreProvider>{element}</StoreProvider>;
};

export const wrapPageElement = ({ element, props }) => {
  return <PrivateRoute {...props}>{element}</PrivateRoute>;
};

export const onClientEntry = () => {
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  if (isIE) {
    alert(
      "此系統並不支援 Internet Explorer\n請使用Google Chrome 或 Microsoft Edge 瀏覽器以獲得最佳瀏覽體驗\n\nThis system does not support Internet Explorer\nPlease use Google Chrome or Microsoft Edge for the best experience",
    );
    window.open("", "_self", "");
    window.close();
  }
  clearStale();

  // aliyun SDK
  loadAliyunUploadSDK();
};
